<script>
import { HorizontalBar, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default HorizontalBar.extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted() {
    /* eslint-disable no-underscore-dangle */
    this.renderChart(this.chartData, this.options);
    this.$emit('chartCreated', this._chart);
  },
});
</script>



// WEBPACK FOOTER //
// BaseHorizontalBarChart.vue?31fbdbb4